import React, { useState, useEffect, useContext } from "react";
import Sales, { ISales } from "../../services/api/Sales";
import Year, { IYear } from "../../services/api/Year";
import Month, { IMonth } from "../../services/api/Month";
import Select from "../../components/Form/Select";
import GroupList from "./components/GroupList";
import ContentHeader from "../../components/ContentHeader";
import { ReactComponent as SalesLogo } from "../../components/ContentHeader/assets/images/sales.svg";
import Loading from "../../components/Loading";
import AuthContext from "../../contexts/AuthContext";

const SalesUpdate: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [sales, setSales] = useState<ISales[]>([]);
  const [years, setYears] = useState<IYear[]>([]);
  const [months, setMonths] = useState<IMonth[]>([]);
  const [loading, isLoading] = useState<Boolean>(true);

  const [year, setYear] = useState<Number>(0);
  const [month, setMonth] = useState<Number>(0);

  const date = new Date();

  async function LoadSales(year: Number, month: Number) {
    try {
      const response: ISales[] = await Sales.GetAll(year, month);    
      setSales(response);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    Promise.all([Year.GetAll(), Month.GetAll()])
        .then((value) => {
          const years = value[0].filter((value) => { return value.active });
          setYears(years);
          setMonths(value[1]);

          setYear(years[0].name);
          setMonth(date.getMonth() + 1);

          LoadSales(years[0].name, date.getMonth() + 1);
          isLoading(false);
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    if (!loading) LoadSales(year, month);
  }, [year, month]);

  function list(obj: any): any {
    return { value: obj.id, label: obj.name };
  }

  return (
    <main className="wrapperApp">
      <ContentHeader
        title="Sales Update"
        Icon={SalesLogo}
        breadcrumb={["Sales Update"]}
      />
      <div id="content">
        <section className="content__block">
          {loading ? (
            <Loading />
          ) : (
            <>
              <div className="content__header">
                <h2 className="content__title">INSERT OR EDIT UNIT DATA</h2>

                <div className="multi-selects">
                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="month"
                      title="Month"
                      disabled={user!.profile.name === "Sender"}
                      options={months.map(list)}
                        value={month}
                      handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
                        setMonth(+event.currentTarget.value);
                      }}
                    />
                  </div>

                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="year"
                      title="Year"
                      disabled={user!.profile.name === "Sender"}
                      options={years.map((obj) => { return { value: obj.name, label: obj.name } })}
                        value={year}
                      handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
                        setYear(+event.currentTarget.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="groups edit__buttons">
                <GroupList data={sales} year={year} month={month} />
              </div>
            </>
          )}
        </section>
      </div>
    </main>
  );
};

export default SalesUpdate;
